// Commonmark default options

import type { Preset } from '../types/preset'

const commonmarkPreset: Preset = {
  options: {
    // Enable HTML tags in source
    html: true,

    // autoconvert URL-like texts to links
    linkify: false,

    // Enable some language-neutral replacements + quotes beautification
    typographer: false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„"' for Russian, '„"‚'' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: '\u201C\u201D\u2018\u2019' /* ""'' */,

    // Internal protection, recursion limit
    maxNesting: 20,
  },

  components: {
    core: {
      rules: ['normalize', 'block', 'inline', 'text_join'],
    },

    block: {
      rules: [
        'blockquote',
        'code',
        'fence',
        'heading',
        'hr',
        'html_block',
        'lheading',
        'list',
        'reference',
        'paragraph',
      ],
    },

    inline: {
      rules: [
        'autolink',
        'backticks',
        'emphasis',
        'entity',
        'escape',
        'html_inline',
        'image',
        'link',
        'newline',
        'text',
      ],
      rules2: ['balance_pairs', 'emphasis', 'fragments_join'],
    },
  },
}

export default commonmarkPreset
